import { Component, OnInit, ChangeDetectionStrategy, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { DxTemplateModule } from 'devextreme-angular/core';
import { DxDataGridModule, DxLookupModule } from 'devextreme-angular';
import { NgIf, AsyncPipe } from '@angular/common';
import { LinkTransferService } from '../services/link-transfer.service';
import { showErrorSwal } from '@asamco/utils';
import { NameIdPair } from '../interfaces/name-id-pair.interface';
import { LinkTransferPreview } from '../interfaces/link-transfer-preview.interface';
import { DxiColumnModule, DxoFilterRowModule, DxoSelectionModule } from 'devextreme-angular/ui/nested';
import { FormsModule } from '@angular/forms';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-shell-link-transfer-tool',
  templateUrl: './link-transfer-tool.component.html',
  styleUrls: ['../styles/alert.scss', '../styles/tile-style.scss', './link-transfer-tool.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [NgIf, FormsModule, DxTemplateModule, AsyncPipe, DxLookupModule, DxoSelectionModule, DxoFilterRowModule, DxiColumnModule, DxDataGridModule]
})
export class LinkTransferToolComponent implements OnInit, OnDestroy {
  public al2Users$: BehaviorSubject<NameIdPair[]> = new BehaviorSubject<NameIdPair[]>(null);
  public linkTransferPreview$: BehaviorSubject<LinkTransferPreview[]> = new BehaviorSubject<LinkTransferPreview[]>(null);
  public al3Companies$: BehaviorSubject<NameIdPair[]> = new BehaviorSubject<NameIdPair[]>(null);

  public al2userId: number;
  public al3companyId: number;

  private destroy$: Subject<void> = new Subject<void>();

  constructor(private cdr: ChangeDetectorRef, private linkTransferService: LinkTransferService) { }

  ngOnInit(): void {
    this.linkTransferService.getSelectableAL2Users().subscribe({ next: sc => this.al2Users$.next(sc), error: showErrorSwal });
    this.linkTransferService.getSelectableCompanies().subscribe({ next: sc => this.al3Companies$.next(sc), error: showErrorSwal });
  }

  onAL2UserChange($event) {
    this.updatePreview();
  }

  onAL3CompanyChange($event) {
    this.updatePreview();
  }

  updatePreview() {
    if (this.al2userId && this.al3companyId) {
      this.linkTransferService.getAL2UserDomainPreview(this.al2userId).subscribe({ next: ud => this.linkTransferPreview$.next(ud), error: showErrorSwal });
    } else {
      this.linkTransferPreview$.next(undefined);
    }
  }

  transferLinks(linkIds: number[]) {
    this.linkTransferService.transferLinks({
      al2LinkIds: linkIds || this.linkTransferPreview$.value.map(lp => lp.id),
      al2UserId: this.al2userId,
      targetCompanyId: this.al3companyId
    }).subscribe({
      next: r => {
        const successes = r.map(rs => rs.successes).reduce((a, c) => a + c, 0);
        const total = r.map(rs => rs.successes + rs.failures).reduce((a, c) => a + c, 0);

        Swal.fire({
          icon: successes === total ? 'success' : 'warning',
          title: `Link transfer completed. Transfering ${successes}/${total} objects succeeded. See the attached file for detailed report.`
        });

        const a = <any>document.getElementById('linkanchor');
        const file = new Blob([JSON.stringify(r)], { type: 'application/json' });
        a.href = URL.createObjectURL(file);
        a.download = 'transferResults.json';
        a.dispatchEvent(new MouseEvent('click'));
      }, error: showErrorSwal
    });
  }

  updatePurchaseOrderCache($event) {
    this.linkTransferService.updatePurchaseOrderCache().subscribe(
      { next: (result: any) => Swal.fire({
        icon: 'success',
        title: 'Purchase Order Cache Updated',
        html: `<strong>Entries added successfully!</strong><br>
               <br>Previous count: <strong>${result.oldEntryCount}</strong>
               <br>New count: <strong>${result.newEntryCount}</strong>
               <br><br><strong>${result.newEntryCount - result.oldEntryCount} new entries</strong> added.`,
        confirmButtonText: 'OK'
    }),error: showErrorSwal });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
